import AuthHomeCustomer from '../models/AuthHomeCustomer'
import AxiosHelper from './AxiosHelper'

class AxiosHomeCustomer extends AxiosHelper {
    static _reqHeadersSet(request) {
        request.headers['Authorization'] = `Bearer ${AuthHomeCustomer.token}`
        request.headers['x-userId'] = AuthHomeCustomer.userId
        request.headers['x-portal'] = AuthHomeCustomer.portalId
    }

    onLogout = () => {
        AuthHomeCustomer.logout()
        let url = `/home-customer/login`
        return this.props.navigate(url)
    }
}

export default AxiosHomeCustomer